import { Button, Drawer, HStack } from '@chakra-ui/react';
import { useCallback, useEffect, useState } from 'react';
import { WebsocketLog } from './WebsocketLog';
import { useTranslation } from 'react-i18next';

import { getCurrentLogSlice, removeLogMessage, SocketLogMessage } from './FriendlyLogger';

interface ConsoleDrawerProps {
  children: React.ReactNode;
}

export const ConsoleDrawer = ({ children }: ConsoleDrawerProps) => {
  const [open, setOpen] = useState(false);
  const [showContent, setShowContent] = useState(open);
  const [logSlice, setLogSlice] = useState<SocketLogMessage[]>([]);

  useEffect(() => {
    let removeContentTimeout: ReturnType<typeof setTimeout> | null = null;
    if (open) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setShowContent(true);
      setLogSlice(getCurrentLogSlice());
    } else {
      removeContentTimeout = setTimeout(() => {
        setShowContent(false);
        setLogSlice([]);
      }, 500);
    }

    return () => {
      if (removeContentTimeout !== null) {
        clearTimeout(removeContentTimeout);
      }
    };
  }, [open]);

  const handleLogClear = useCallback(() => {
    removeLogMessage(...logSlice.map((l) => l.id));
    setLogSlice([]);
  }, [logSlice]);

  const { t } = useTranslation('translation', { keyPrefix: 'planner.log' });

  return (
    <Drawer.Root placement="left" size="narrow" onOpenChange={(det) => setOpen(det.open)}>
      <Drawer.Backdrop />
      <Drawer.Trigger asChild>{children}</Drawer.Trigger>
      <Drawer.Positioner>
        <Drawer.Content>
          <Drawer.Header>
            <Drawer.Title as="h2">{t('title')}</Drawer.Title>
            <HStack justifyContent="flex-end" gap="10px">
              <Button size="small" onClick={handleLogClear}>
                {t('clear')}
              </Button>
              <Drawer.CloseTrigger asChild>
                <Button size="small">{t('close')}</Button>
              </Drawer.CloseTrigger>
            </HStack>
          </Drawer.Header>
          <Drawer.Body>{showContent && <WebsocketLog logSlice={logSlice} />}</Drawer.Body>
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>
  );
};
